import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = { class: "mr-2" }

export function render(_ctx, _cache) {
  const _component_v_icon = _resolveComponent("v-icon")
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")
  const _component_v_list_item = _resolveComponent("v-list-item")
  const _component_v_list = _resolveComponent("v-list")
  const _component_v_menu = _resolveComponent("v-menu")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.fullname), 1),
    _createVNode(_component_v_menu, {
      modelValue: _ctx.isInfoMenuVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.isInfoMenuVisible) = $event))
    }, {
      activator: _withCtx(({ props }) => [
        _createVNode(_component_v_icon, _mergeProps(props, {
          size: "x-large",
          color: "primary"
        }), {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode(" mdi-information-variant ", -1)
          ]))]),
          _: 1
        }, 16)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_list, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoMenuItems, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                (item.action)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 0,
                      onClick: item.action
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (item.href)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 1,
                        href: item.href,
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["href"]))
                    : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_menu, {
      modelValue: _ctx.isAccountMenuVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.isAccountMenuVisible) = $event))
    }, {
      activator: _withCtx(({ props }) => [
        _createVNode(_component_v_icon, _mergeProps(props, {
          size: "x-large",
          color: "primary"
        }), {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode(" mdi-account ", -1)
          ]))]),
          _: 1
        }, 16)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_list, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountMenuItems, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                (item.action)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 0,
                      onClick: item.action
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (item.href)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 1,
                        href: item.href,
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["href"]))
                    : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}